module.exports = __webpack_public_path__ + "img/rongyu_pt.227db648.png";